/* eslint-disable */
import React, {useState} from "react";
import {Box, Stack, Typography} from "@mui/material";
import {GREY, PRIMARY} from "@/theme/palette";
import {useTranslation} from "react-i18next";
import {Icon} from '@iconify/react';
import closeSquareOutline from '@iconify/icons-eva/close-square-outline';

const NoImage = (
    {
        width,
        height
    }: any
): any => {
    const {t} = useTranslation();

    return <>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                    bgcolor: GREY["50032"],
                    width: (width || 130),
                    height: (height || 130),
                    borderRadius: 1
                }}
            >
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}
                >
                    <Icon icon={closeSquareOutline} width="40" color={PRIMARY.main}/>

                    <Typography variant="caption" display="block" gutterBottom color={"primary"}>
                        {t('common.not_found')}
                    </Typography>
                </Stack>
            </Box>
    </>
}

export default NoImage;
